export default __webpack_public_path__ + "static/media/2034.8a4052e5.png";